import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckboxIndeterminateSolid = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm3 8h6a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2Z",
		fill: "var(--main-color)"
	})
});
export { SvgCheckboxIndeterminateSolid as ReactComponent };
